import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentMethodXStore } from "src/models/Stores/PaymentMethodXStore.models";

interface PaymentMethodXStoreState {
  paymentMethodXStores: IPaymentMethodXStore[];
  paymentMethodXStoreToEdit: IPaymentMethodXStore | null;
}

const initialState: PaymentMethodXStoreState = {
  paymentMethodXStores: [],
  paymentMethodXStoreToEdit: null,
};

const paymentMethodXStoreSlice = createSlice({
  name: "PaymentMethodXStore",
  initialState,
  reducers: {
    setPaymentMethodXStoreList: (
      state,
      action: PayloadAction<IPaymentMethodXStore[]>
    ) => {
      state.paymentMethodXStores = action.payload;
    },
    concatListPaymentMethodXStore: (
      state: PaymentMethodXStoreState,
      action: PayloadAction<IPaymentMethodXStore[]>
    ) => {
      state.paymentMethodXStores = [
        ...state.paymentMethodXStores.concat(action.payload),
      ];
    },
    setPaymentMethodXStoreToEdit: (
      state,
      action: PayloadAction<IPaymentMethodXStore | null>
    ) => {
      state.paymentMethodXStoreToEdit = action.payload;
    },
    addPaymentMethodXStore: (
      state,
      action: PayloadAction<IPaymentMethodXStore>
    ) => {
      state.paymentMethodXStores.push(action.payload);
    },
    updatePaymentMethodXStore: (
      state,
      action: PayloadAction<IPaymentMethodXStore>
    ) => {
      let itemIndex = state.paymentMethodXStores.findIndex(
        item =>
          item.paymentMethodXStoreId === action.payload.paymentMethodXStoreId
      );
      if (itemIndex !== -1)
        state.paymentMethodXStores[itemIndex] = action.payload;
    },
    deletePaymentMethodXStore: (state, action: PayloadAction<number>) => {
      const newArray = state.paymentMethodXStores.filter(
        item => item.paymentMethodXStoreId !== action.payload
      );
      state.paymentMethodXStores = newArray;
    },
  },
});

export const {
  setPaymentMethodXStoreList,
  concatListPaymentMethodXStore,
  setPaymentMethodXStoreToEdit,
  addPaymentMethodXStore,
  updatePaymentMethodXStore,
  deletePaymentMethodXStore,
} = paymentMethodXStoreSlice.actions;

export default paymentMethodXStoreSlice.reducer;
